import React, { useEffect, useState } from "react";
import AuthRoutes from "./authRoutes";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GlobalAdminRoutes } from "./globalAdminRoutes";
import { globalLeaderRoutes } from "./globalLeaderRoutes";
import { GlobalUserRoutes } from "./globalUserRoutes";
import { useDispatch, useSelector } from "react-redux";
import { checkuser } from "../actions/user";

import NotFoundPage from "../pages/NotFoundPage";
import AuthWrapper from "./AuthWrapper";
import { Spin } from "antd";
import { removeToken } from "../auth";
import { globalControllerRoutes } from "./globalControllerRoutes";

const AppRoutes = () => {
  const AdminRoutes: any[] = [...AuthRoutes, ...GlobalAdminRoutes];
  const LeaderRoutes: any[] = [...AuthRoutes, ...globalLeaderRoutes];
  const ControllerRoutes: any[] = [...AuthRoutes, ...globalControllerRoutes];
  const UserRoutes: any[] = [...AuthRoutes, ...GlobalUserRoutes];
  const dispatch: any = useDispatch();
  const user = useSelector((state: any) => state?.Auth);
  const loadingGlobal = useSelector((state: any) => state?.General);
  const [initialRoutes, setInitialRoutes] = useState<any>(AdminRoutes);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      dispatch(
        checkuser((res: any) => {
          if (res?.status === 401 || res?.status === 403) {
            removeToken();
            window.location.href = "/";
          }
        })
      );
    }
  }, [token]);

  const userData: any = user?.user?.data || user?.user?.user;
  useEffect(() => {
    if (!userData?.roleId) {
      setLoading(true);
    } else {
      setLoading(false);
      if (userData?.roleId === 1) {
        setInitialRoutes(AdminRoutes);
      } else if (userData?.roleId === 2) {
        setInitialRoutes(LeaderRoutes);
      } else if (userData?.roleId === 3) {
        setInitialRoutes(ControllerRoutes);
      } else if (userData?.roleId === 4) {
        setInitialRoutes(UserRoutes);
      }
    }
  }, [userData]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  if (loading || loadingGlobal?.loading) {
    return <Spin fullscreen>Loading... </Spin>;
  }

  return (
    <Router>
      <Routes>
        {initialRoutes.map(
          (
            { path, layout: Layout, component: Component }: any,
            index: number
          ) => (
            <Route
              key={index + 2}
              path={path}
              element={
                <AuthWrapper roleId={userData?.roleId}>
                  <Layout>
                    <Component />
                  </Layout>
                </AuthWrapper>
              }
            />
          )
        )}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
